// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609300134/js/" + chunkId + "." + {"44":"fa655449","225":"cd1ea176","481":"11b86ef1","486":"50492f29","770":"fc2f2232"}[chunkId] + ".0.04638128881445114.chunk.js";
};